// extracted by mini-css-extract-plugin
export default {"button":"ntKNd_","clipboardFocusRing":"rx6417","secondary":"EwBavj","isMuted":"v7Ydcc","wrapper":"I4gY7Y","fixedPrimary":"lDdct5","fixedSecondary":"L4KUvL"};